(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["shd-all-collections"] && !window.DesignMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', ()=>{
    addAnimationToElements({
      selector: '[data-animate-selector="all-collections"]',
      animateName: 'fade-in-bottom',
      initialStateName: 'fade-in-bottom',
      interval: 500
    });
  })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shd-discover-category"] && !window.DesignMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', ()=>{
    addAnimationToElements({
      selector: '[data-animate-selector="category"]',
      animateName: 'fade-in-bottom',
      initialStateName: 'fade-in-bottom',
      interval: 500
    });
  })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shd-faq"] && !window.DesignMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const faqs = document.querySelectorAll('.faq');

    faqs.forEach(function (faq) {
      faq.addEventListener('click', function () {
        const questionContainer = faq.querySelector('.question-container');
        const iconContainer = faq.querySelector('.icon-container img');

        // Remove active-faq class from all other FAQs
        faqs.forEach(function (otherFaq) {
          const otherQuestionContainer = otherFaq.querySelector('.question-container');
          const otherIconContainer = otherFaq.querySelector('.icon-container img');

          if (otherQuestionContainer !== questionContainer) {
            otherQuestionContainer.classList.remove('active-faq');
            if (otherIconContainer) {
              otherIconContainer.classList.remove('rotate-icon');
            }
          }
        });

        // Toggle the active class for the clicked FAQ
        questionContainer.classList.toggle('active-faq');

        if (iconContainer) {
          iconContainer.classList.toggle('rotate-icon');
        }
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shd-show-products"] && !window.DesignMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', ()=>{
    addAnimationToElements({
      selector: '[data-animate-selector="product-column"]',
      animateName: 'fade-in-bottom',
      initialStateName: 'fade-in-bottom',
      interval: 500
    });
  })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shd-spec-two"] && !window.DesignMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', ()=>{
    addAnimationToElements({
      selector: '[data-animate-selector="spec-container"]',
      animateName: 'fade-in-bottom',
      initialStateName: 'fade-in-bottom',
      interval: 500
    })
  })

  } catch(e) { console.error(e); }
})();
})();
